module.exports = __webpack_public_path__ + "static/img/sm.734a31a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sm.jpg
// module id = nhG4
// module chunks = 1